import { useCallback, useEffect } from 'react';

import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import LoadingIndicator from '@sayyesschool/frontend/components/loading-indicator';
import Page from '@sayyesschool/frontend/components/page';
import PageContent from '@sayyesschool/frontend/components/page-content';
import PageHeader from '@sayyesschool/frontend/components/page-header';
import { useMaterials } from '@sayyesschool/frontend/features/materials';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import MaterialForm from '../material-form';
import MaterialsGrid from '../materials-grid';

export default function MaterialsPage() {
    const [materials, actions] = useMaterials();

    const [isFormOpen, toggleFormOpen] = useBoolean(false);

    useEffect(() => {
        actions.getMaterials();
    }, [actions]);

    const handleSubmit = useCallback(data => {
        return actions.createMaterial(data)
            .then(() => toggleFormOpen(false));
    }, [actions, toggleFormOpen]);

    if (!materials) return <LoadingIndicator fullscreen />;

    return (
        <Page
            id="materials"
            loading={!materials}
        >
            <PageHeader
                title="Материалы"
                actions={[
                    {
                        key: 'add',
                        content: 'Создать материал',
                        icon: 'add',
                        variant: 'solid',
                        onClick: toggleFormOpen
                    }
                ]}
            />

            <PageContent>
                <MaterialsGrid materials={materials} />
            </PageContent>

            <FormDialog
                title="Новый материал"
                open={isFormOpen}
                onClose={toggleFormOpen}
            >
                <MaterialForm onSubmit={handleSubmit} />
            </FormDialog>
        </Page>
    );
}